import { FormControl, Validators } from '@angular/forms';
import {
  EoCustomControlConfig,
  EoDropdownConfig,
  EoFormPanelConfig,
  EoInputConfig,
} from 'ngx-eo-web-components';
import { Confirmation } from 'primeng/api';
import { roles } from '../../shared/components/role-dropdown/role-dropdown.config';

export const header = 'Διαχείριση Χρηστών';

export const panel1 = new EoFormPanelConfig({
  name: 'form',
  panelContentStyleClass: 'grid',
  config: [
    new EoInputConfig({
      name: 'QueryTerm',
      styleClass: 'col-6',
      type: 'text',
      label: 'Username / Email',
      placeholder: 'Παρακαλώ συμπληρώστε το Username / Email',
      control: new FormControl(''),
    }),
    new EoDropdownConfig({
      name: 'Role',
      label: 'Ρόλος',
      placeholder: 'Επιλέξτε ένα ρόλο',
      styleClass: 'col-6',
      options: roles,
      optionLabel: 'label',
      optionValue: 'value',
      appendTo: 'body',
      control: new FormControl(null),
    })
  ],
});

export const userSearchFormConfig: EoFormPanelConfig[] = [panel1];
